import React from 'react';

const ManualEntryForm = ({ manualEntry, handleManualSubmit }) => {
  if (!manualEntry) return null;
  return (
    <form className="manual-entry-form" onSubmit={handleManualSubmit} style={{ background: '#fff', padding: 16, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', maxWidth: 350, margin: '20px auto' }}>
      <h5>Manual Entry</h5>
      <div>Barcode: {manualEntry.barcode}</div>
      <input name="name" placeholder="Product Name" required className="form-control my-2" />
      <input name="calories" type="number" placeholder="Calories" required className="form-control my-2" />
      <input name="protein" type="number" placeholder="Protein (g)" required className="form-control my-2" />
      <input name="carbs" type="number" placeholder="Carbs (g)" required className="form-control my-2" />
      <input name="fat" type="number" placeholder="Fat (g)" required className="form-control my-2" />
      <input name="serving_size" placeholder="Serving Size (optional)" className="form-control my-2" />
      <input name="description" placeholder="Description (optional)" className="form-control my-2" />
      <button type="submit" className="btn btn-primary w-100">Save</button>
    </form>
  );
};

export default ManualEntryForm;
